document.addEventListener('DOMContentLoaded', () => {

    let imagesSliders = document.querySelectorAll('.images-sliders');
    if(imagesSliders){
        imagesSliders.forEach((item)=>{
            new Swiper(item, {
                rewind: true,
                effect: "fade",
                fadeEffect: {
                    "crossFade": true
                },
                pagination: {
                    el: ".pagination-images",
                    clickable: true,
                },
                navigation: {
                    nextEl: ".sw-but-img-next",
                    prevEl: ".sw-but-img-prev",
                },
            });
        });
    }

    let swiperTop = document.querySelectorAll('.swiper-top');
    if(swiperTop){
        let progressCircle = document.querySelector(".autoplay-progress svg");
        swiperTop.forEach((slider)=>{
            new Swiper(slider, {
                loop: true,
                effect: "fade",
                speed: 1000,
                fadeEffect: {
                    "crossFade": true
                },
                autoplay: {
                    delay: 8000,
                    disableOnInteraction: false,
                },
                on: {
                    autoplayTimeLeft(s, time, progress) {
                        progressCircle.style.setProperty("--progress", 1 - progress);
                    }
                }
            });
        });
    }

    let gallerySlider = document.querySelectorAll('.gallery-slider');
    if(gallerySlider){
        gallerySlider.forEach((slider)=> {
            new Swiper(slider, {
                loop: true,
                slidesPerView: "auto",
                spaceBetween: 25,
                fadeEffect: {
                    "crossFade": true
                },
                navigation: {
                    nextEl: ".sw-gal-next",
                    prevEl: ".sw-gal-prev",
                },
                breakpoints: {
                    600: {
                        spaceBetween: 35,
                    }
                }
            });
        });
    }

    let sliderDoubleSlide = document.querySelectorAll('.slider-double-slide');
    if(sliderDoubleSlide){
        let slider_double = new Swiper('.slider-double-slide', {
            effect: "fade",
            loop: true,
            fadeEffect: {
                "crossFade": true
            },
            speed: 1000,
            autoplay: {
                delay: 6000,
                disableOnInteraction: false,
            },
            navigation: {
                nextEl: ".sw-but-next",
                prevEl: ".sw-but-prev",
            },
            pagination: {
                el: ".pagination-slider",
                clickable: true,
            },
            breakpoints: {
                600: {
                   loop: false,
                   rewind: true
                }
            }
        });

        let slider_mini = new Swiper('.slider-mini-slide', {
            loop: false,
            slidesPerView: "auto",
            spaceBetween: 20,
            on: {
                click(event) {
                    const slideIndex = event.clickedSlide.getAttribute('data-slide');
                    slider_double.slideTo(slideIndex);
                },
            }
        });

        slider_double.on('slideChange', function () {
            slider_mini.slideTo(this.realIndex);
        });
    }

    let awardsSliders = document.querySelectorAll('.awards-sliders');
    if(awardsSliders){
        awardsSliders.forEach((slider)=>{
            new Swiper(slider, {
                loop: true,
                slidesPerView: 3,
                uniqueNavElements:false,
                spaceBetween: 0,
                fadeEffect: {
                    "crossFade": true
                },
                navigation: {
                    nextEl: ".awa-but-next",
                    prevEl: ".awa-but-prev",
                },
                breakpoints: {
                    600: {
                        slidesPerView: 3,
                        spaceBetween: 25,
                    }
                }
            });
        });
    }

    let reviewsSlides = document.querySelectorAll('.reviews-slides');
    if(reviewsSlides){
        reviewsSlides.forEach((slider)=>{
            new Swiper(slider, {
                rewind: true,
                effect: "fade",
                fadeEffect: {
                    "crossFade": true
                },
                navigation: {
                    nextEl: ".sw-but-next",
                    prevEl: ".sw-but-prev",
                },
            });
        });
    }

    let sliderSlide = document.querySelectorAll('.slider-slide');
    if(sliderSlide){
        sliderSlide.forEach((slider)=> {
            new Swiper(slider, {
                loop: true,
                effect: "fade",
                autoHeight: true,
                fadeEffect: {
                    "crossFade": true
                },
                navigation: {
                    nextEl: ".sw-but-next",
                    prevEl: ".sw-but-prev",
                },
                breakpoints: {
                    600: {
                        autoHeight: false,
                    }
                }
            });
        });
    }

    let carouselSlider = document.querySelectorAll('.carousel-slider');
    if(carouselSlider){
        carouselSlider.forEach((slider)=> {
            new Swiper(slider, {
                rewind: true,
                effect: "fade",
                autoHeight: true,
                fadeEffect: {
                    "crossFade": true
                },
                navigation: {
                    nextEl: ".sw-but-next",
                    prevEl: ".sw-but-prev",
                },
                breakpoints: {
                    600: {
                        autoHeight: false,
                    }
                }
            });
        });
    }


});